import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
import ImageViewer from "../../../components/ImageViewer";
import { printDate, printLocation } from "../../../utils/helper";
import React, { useState, useEffect } from "react";
import { companyProfile, customPermission, userRole } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import ModalChangeRole from "./modal/changeRoles";
import ConfirmationDlg from "../../../components/ConfirmationDlg";

function RolesConfiguration() {
  const [userRoles, setUserRoles] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteRow, setDeleteRow] = useState(null);
  const [confirmDlg, setConfirmDlg] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [location_wording, setLocation_wording] = useState([]);
  const [data, setData] = useState([]);
  const [customPermissions, setCustomPermissions] = useState([]);

  async function GetRoles() {
    try {
      const res = await userRole.list();
      const datas = await parserAPI(res);
      setData(datas);
    } catch (e) {
      console.error(e);
    }
  }
  async function getCustomPermissions() {
    try {
      const res = await customPermission.list();
      const datas = await parserAPI(res);
      setCustomPermissions(datas);
    } catch (e) {
      console.error(e);
    }
  }
  useEffect(() => {
    GetRoles();
    getCustomPermissions();
  }, []);
  async function deleteUserRoleConfirm(row) {
    setDeleteRow(row);
    setConfirmDlg(true);
  }
  async function deleteUserRole() {
    try {
      const response = await userRole.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          toast.success("This role has been deleted");
          setConfirmDlg(false);
          setDeleteRow(null);
        } else {
          toast.error(body.message);
        }

        GetRoles();
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  function addUserRole(value) {
    setOpenDetail(true);
  }
  function editUserRole(value) {
    setSelectedRow(value);
    setOpenDetail(true);
  }

  const columns = [
    {
      name: "Role Name",
      selector: (row) => row.rolename,
    },
    {
      name: "Sensor Online Status",
      minWidth: "200px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        const dashboard_features = [
          "Machine Online Status",
          "Machine Health",
          "Machine Uptime",
          "Machine Alert Status",
        ];
        const alert_features = [
          "Alert Count",
          "Alert Details",
          "Manual Alert Entry",
        ];
        var dt = "";
        const MPitem = "MACHINE PROFILES";
        const Gina = "GINA Feature";
        if (row.roleFeatureAccess) {
          var text = [];
          if (
            row.roleFeatureAccess.some(
              (sv) =>
                dashboard_features.indexOf(sv.page_name) >= 0 &&
                (sv.can_view == true ||
                  sv.can_create == true ||
                  sv.can_update == true ||
                  sv.can_delete == true)
            )
          ) {
            text.push("Dashboard");
          }
          if (
            row.roleFeatureAccess.some(
              (sv) =>
                alert_features.indexOf(sv.page_name) >= 0 &&
                (sv.can_view == true ||
                  sv.can_create == true ||
                  sv.can_update == true ||
                  sv.can_delete == true)
            )
          ) {
            text.push("Alert");
          }
          if (
            row.roleFeatureAccess.some(
              (sv) =>
                MPitem.indexOf(sv.page_name) >= 0 &&
                (sv.can_view == true ||
                  sv.can_create == true ||
                  sv.can_update == true ||
                  sv.can_delete == true)
            )
          ) {
            text.push("Machine Profile");
          }
          if (
            row.roleFeatureAccess.some(
              (sv) =>
                Gina.indexOf(sv.page_name) >= 0 &&
                (sv.can_view == true ||
                  sv.can_create == true ||
                  sv.can_update == true ||
                  sv.can_delete == true)
            )
          ) {
            text.push("Gina Feature");
          }
          dt = text.join(", ");
        }
        return <span>{dt}</span>;
      },
    },
    {
      name: "Action",
      width: "150px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return (
          <div>
            <button
              onClick={() => {
                editUserRole(row);
              }}
              className="btn btn-sm btn-outline-theme mx-1"
            >
              <i className="fa fa-edit"></i>
            </button>
            <button
              onClick={() => {
                deleteUserRoleConfirm(row);
              }}
              className="btn btn-sm btn-outline-danger"
            >
              <i className="fa fa-trash"></i>
            </button>
          </div>
        );
      },
    },
  ];
  async function onSubmit({
    name,
    userRoleFeatureAccess,
    accesses,
    status,
    overviewPage,
  }) {
    let data = {
      rolename: name,
      accesses,
      feature_accesses: userRoleFeatureAccess.map((fa) => ({
        page_name: fa.name,
        ...fa,
        name: undefined,
      })),
      overview_page: overviewPage,
      //is_active: status == "1" ? true : false,
    };

    if (!selectedRow) {
      const response = await userRole.create(data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Role " + name + " is successfully added");
          setSelectedRow(null);
          setOpenDetail(false);
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    } else {
      const response = await userRole.update(selectedRow.id, data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Role " + name + " is successfully added");
          setSelectedRow(null);
          setOpenDetail(false);
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    }
    GetRoles();
  }

  return (
    <div>
      <ConfirmationDlg
        open={confirmDlg}
        onClose={() => {
          setConfirmDlg(false);
          setDeleteRow(null);
        }}
        onSubmit={deleteUserRole}
      >
        <div>Are you sure you want to delete this role?</div>
      </ConfirmationDlg>
      <ModalChangeRole
        onSubmit={onSubmit}
        open={openDetail}
        row={selectedRow}
        customPermissions={customPermissions}
        onClose={() => {
          setSelectedRow(null);
          setOpenDetail(false);
        }}
      ></ModalChangeRole>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Configuration</a>
            </li>
            <li className="breadcrumb-item active">User Roles</li>
          </ol>
          <h1 className="page-header mb-0">User Roles</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-12 ">
          <div className="row justify-content-end">
            <div className="col-sm-3 mb-2 mb-sm-0">
              <button
                onClick={addUserRole}
                className="btn btn-outline-theme w-100"
              >
                Add Role <i className="bi bi-plus"></i>
              </button>
            </div>
          </div>
          <Card className="mb-4 mt-2">
            <CardHeader>Update Role</CardHeader>
            <CardBody>
              <DataTable
                highlightOnHover
                theme="dark"
                columns={columns}
                data={data}
                pagination
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default RolesConfiguration;
